import type ArticleLocal from "~/libs/interfaces/ArticleLocal";
import type {Article} from "~/graphql/__generated__/graphql";
import {useHtmlToPlainText} from "~/composables/useHtmlToPlainText";
import type {Recommendation} from "recombee-api-client";

const articleLocalFactory = {
  createArticleLocalFromArticle(article: Article): ArticleLocal {
    const author = article?.authorList?.edges?.at(0)?.node
    return {
      ...article,
      ...(author && {
        simpleAuthor: {
          id: author.id as string,
          name: author.fullname as string,
          ...(author.imageAsset?.urlWithProtocol && {
            imageUrlWithProtocol: author.imageAsset?.urlWithProtocol as string
          }),
        },
      }),
      isVisible: true,
      ...(article.published && {
        publishedDate: new Date(article.published)
      }),
      ...(article.jsonBody && {
        jsonBodyDecoded: JSON.parse(article.jsonBody)
      }),
      ...(article.body && {
        bodyPlain: useHtmlToPlainText(article.body)
      }),
      ...(article.rating && {
        ratingDecoded: JSON.parse(article.rating)
      }),
    }
  },
  createArticleLocalFromRecombeeArticle(recommendation: Recommendation): ArticleLocal {
    const values = recommendation.values
    const categories = []
    if (values?.categories && Array.isArray(values?.categories)) {
      for (let i in values?.categories) {
        categories.push({
          node: {
            name: values?.categories[i]
          }
        })
      }
    }
    return {
      id: recommendation.id,
      title: values?.title,
      perex: values?.description,
      path: values?.articleUrl,
      authorsString: values?.author as string,
      isVisible: true,
      previewAsset: {
        urlWithProtocol: values?.image_large || values?.imageUrl || values?.image
      },
      categoryList: {
        edges: categories
      },
      url: values?.url,
      magazineName: values?.magazine_name,
    } as ArticleLocal
  }
}
export default articleLocalFactory
